import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLineHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.25 12h-5.5M19.25 17.25h-5.5M19.25 6.75h-5.5M5.75 7.25 8 4.75l2.25 2.5M5.75 16.75 8 19.25l2.25-2.5M8 5.5v13"
    />
  </svg>
);
export default SvgLineHeight;
